import React, { memo } from 'react';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Autorenew from '@mui/icons-material/Autorenew';
import CheckCircle from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import Schedule from '@mui/icons-material/Schedule';
import type SvgIcon from '@mui/material/SvgIcon';
import { JobStatus } from './jobModel';

type PaletteKey = 'success' | 'info' | 'warning' | 'error';

export const JOB_STATUS_META: Record<JobStatus, { label: string; Icon: typeof SvgIcon; color: PaletteKey }> = {
  completed: { label: 'Completed', Icon: CheckCircle, color: 'success' },
  processing: { label: 'Running', Icon: Autorenew, color: 'info' },
  pending: { label: 'Queued', Icon: Schedule, color: 'warning' },
  failed: { label: 'Failed', Icon: ErrorIcon, color: 'error' },
};

const JobStatusChip: React.FC<{ status: JobStatus }> = ({ status }) => {
  const { label, Icon, color } = JOB_STATUS_META[status];
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        height: 28,
        pl: 1,
        pr: 1.25,
        borderRadius: 14,
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        color: `${color}.main`,
        bgcolor: (theme) => alpha(theme.palette[color].main, 0.14),
      }}
    >
      <Icon sx={{ fontSize: 16 }} />
      {label}
    </Box>
  );
};

export default memo(JobStatusChip);
